import { useEffect } from 'react'
import { SITE_URL } from '../../utils/constants'
import { IPage, IPageState, ISearchItemState } from './SearchPage.types'

export const useRestoreState = (
  pressStateArg: ISearchItemState,
  setPressState: (pressState: ISearchItemState) => void,
  collectionName: string,
  saveState: boolean
) => {
  let isScrolled = false

  const handleScroll = () => {
    isScrolled = true
  }

  useEffect(() => {
    if (!saveState) return

    const pageStateJSON = localStorage.getItem('pageState')
    const scrollStateJSON = localStorage.getItem('scrollState')

    if (pageStateJSON && scrollStateJSON) {
      document.addEventListener('wheel', handleScroll)
      const desiredState = { ...JSON.parse(pageStateJSON), ...JSON.parse(scrollStateJSON) }

      void restoreState(desiredState)
    }
  }, [])

  const restoreState = async (desiredState: IPageState) => {
    let currentPageState: ISearchItemState = pressStateArg

    while (currentPageState.nextPage !== desiredState.nextPage) {
      if (isScrolled) break

      const nextPageUrl = `${SITE_URL}jsonPages/${collectionName}/${currentPageState.nextPage}.json`

      await fetch(nextPageUrl)
        .then((result) => result.json())
        .then(({ hasMore, content }: IPage) => {
          currentPageState = {
            hasMore,
            nextPage: +currentPageState.nextPage + 1,
            content: currentPageState.content.concat(content),
          }
        })
        .catch(console.error)
    }

    if (currentPageState.nextPage === desiredState.nextPage) {
      setTimeout(() => {
        window.scrollTo({ top: desiredState.scrollPosition, behavior: 'smooth' })
      }, 500)
      setPressState(currentPageState)
    }

    document.removeEventListener('wheel', handleScroll)
  }
}
